<template>

</template>

<script>
import NBread from "@/partials/bread";
export default {
  components: {
    NBread,
  },
  computed: {
  },
  created() {
    this.go()
  },
  methods: {
    go() {
      axios.get('/api/v1/google/callback')
          .then(() => {
            window.location.href = '/dashboard'
          })
    }
  },
};
</script>
